import { t } from '@/i18n';

/**
 * TRAD-2995 — 금융캘린더 투자 면책(iOS Disclaimer.Body.FinancialCalendar / android financial_calendar_disclaimer 문구 그대로).
 * TRAD-3709 — 메인 캘린더 하단에 있던 문단을 그대로 뽑았다(마크업·클래스 동일). 일자별 페이지도 이걸 쓴다 — 같은 문단을 두 벌 두지 않는다
 * (임의 폰트 크기 래칫이 두 번째 사본을 잡았다).
 */
export const CalendarDisclaimer = () => (
  <p className="mt-6 px-4 text-[11px] text-muted-foreground leading-relaxed">{t('financial_calendar.disclaimer')}</p>
);
